import type { ReactNode, Ref } from 'react'
import type { ListingSeoIntroView } from '@shared/lib/seo/listing/buildListingSeoIntroView'
import { baselineSlotAttr } from '@shared/lib/baseline/slotRegistry'
import titleStyles from '@shared/ui/Typography/Title/Title.module.sass'
import textStyles from '@shared/ui/Typography/Text/Text.module.sass'
import s from './ListingDescriptionPage.module.sass'

type Props = ListingSeoIntroView & {
  rootClassName?: string
  expanded?: boolean
  clipped?: boolean
  contentRef?: Ref<HTMLDivElement>
  enhance?: ReactNode
}

/**
 * @function ListingDescriptionContent
 * @description shared разметка intro — без hooks, пригодна для Server Component
 */
export const ListingDescriptionContent = ({
  title,
  description,
  rootClassName = '',
  expanded = false,
  clipped = true,
  contentRef,
  enhance = null,
}: Props) => {
  if (!title && !description) return null

  const contentClassName = [
    s['description-content'],
    clipped ? s['description-content--micro'] : '',
    expanded ? s['description-content--open'] : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={[s['description-root'], rootClassName].filter(Boolean).join(' ')}
      data-listing-description-root
      {...baselineSlotAttr('listing.intro')}>
      {title && (
        <h1
          className={`${titleStyles.header} ${s['main-title']}`}
          data-size='h1'
          data-super='false'
          {...baselineSlotAttr('listing.h1')}>
          {title}
        </h1>
      )}

      {description && (
        <div className={s['description-wrapper']}>
          <div ref={contentRef} className={contentClassName}>
            <p className={`${textStyles.text} ${s['main-description']}`} data-size='M'>
              {description}
            </p>
          </div>
          {enhance}
        </div>
      )}
    </div>
  )
}
